/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { SecurityScheme } from '../../core/models/common/SecurityScheme';

/**
 * A command used to modify a security scheme.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export abstract class ChangeSecuritySchemeCommand extends AbstractCommand {
    public _schemeName : string;

    public _schemeObj : any;

    public _oldScheme : any;

    public constructor(scheme? : any) {
        if(((scheme != null && scheme instanceof <any>SecurityScheme) || scheme === null)) {
            let __args = arguments;
            super();
            if(this._schemeName===undefined) this._schemeName = null;
            if(this._schemeObj===undefined) this._schemeObj = null;
            if(this._oldScheme===undefined) this._oldScheme = null;
            if(this._schemeName===undefined) this._schemeName = null;
            if(this._schemeObj===undefined) this._schemeObj = null;
            if(this._oldScheme===undefined) this._oldScheme = null;
            (() => {
                this._schemeName = scheme.getName();
                this._schemeObj = Library.writeNode(scheme);
            })();
        } else if(scheme === undefined) {
            let __args = arguments;
            super();
            if(this._schemeName===undefined) this._schemeName = null;
            if(this._schemeObj===undefined) this._schemeObj = null;
            if(this._oldScheme===undefined) this._oldScheme = null;
            if(this._schemeName===undefined) this._schemeName = null;
            if(this._schemeObj===undefined) this._schemeObj = null;
            if(this._oldScheme===undefined) this._oldScheme = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[ChangeSecuritySchemeCommand] Executing.");
        this._oldScheme = null;
        let scheme : SecurityScheme = this.getSchemeFromDocument(document);
        if(this.isNullOrUndefined(scheme)) {
            return;
        }
        this._oldScheme = Library.writeNode(scheme);
        this.replaceSchemeWith(scheme, this._schemeObj);
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[ChangeSecuritySchemeCommand] Reverting.");
        if(this.isNullOrUndefined(this._oldScheme)) {
            return;
        }
        let scheme : SecurityScheme = this.getSchemeFromDocument(document);
        if(this.isNullOrUndefined(scheme)) {
            return;
        }
        this.nullScheme(scheme);
        Library.readNode(this._oldScheme, scheme);
    }

    /**
     * Gets the scheme from the document.
     * @param {Document} document
     * @return {SecurityScheme}
     */
    abstract getSchemeFromDocument(document : Document) : SecurityScheme;

    /**
     * Replaces the content of a scheme with the content from another scheme.
     * @param {SecurityScheme} toScheme
     * @param {*} fromScheme
     */
    replaceSchemeWith(toScheme : SecurityScheme, fromScheme : any) {
        this.nullScheme(toScheme);
        Library.readNode(fromScheme, toScheme);
    }

    /**
     * Null out all values in the given scheme.
     * @param {SecurityScheme} scheme
     */
    nullScheme(scheme : SecurityScheme) {
        scheme.description = null;
        scheme.type = null;
        scheme.name = null;
        scheme.in = null;
    }
}
ChangeSecuritySchemeCommand["__class"] = "io.apicurio.datamodels.cmd.commands.ChangeSecuritySchemeCommand";
ChangeSecuritySchemeCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];





import { MarshallCompat } from '../../compat/MarshallCompat';

